/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
//import '../../css/event210521.css'
//import '../../css/event210629.css'
//import '../../css/event210819.css'
import "../../css/event211020.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
// import { isMobile } from "react-device-detect";
import $ from "jquery";

class Event20220425_costory extends Component {
  state = {
    eventCode: 0,
    tabIndex: 3,
    slideIndex: 0,
    slidePlay: true,
  };
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _instar = () => {
    window.open(
      "https://www.instagram.com/p/CdVDCeOpgUI/?utm_source=ig_web_copy_link",
      "",
      ""
    );
  };
  _twitter = () => {
    window.open(
      "https://twitter.com/ANIPLUSTV/status/1523563332082434048",
      "",
      ""
    );
  };
  _google = () => {
    window.open(
      "https://www.youtube.com/post/UgkxkOjBcpL-a-ITiMZdMuW1uyNyiSpynuF2",
      "",
      ""
    );
  };
  render() {
    // const { bannerList, tabIndex, slideIndex } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>코스토리 방송 기념 이벤트</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <Fragment>
            <map name="Map2">
              <area
                onClick={this._twitter}
                style={{ cursor: "pointer" }}
                shape="rect"
                coords="140, 2884, 572, 2969"
              />
              <area
                onClick={this._instar}
                style={{ cursor: "pointer" }}
                shape="rect"
                coords="649, 2879, 1065, 2971"
              />
              <area
                onClick={this._google}
                style={{ cursor: "pointer" }}
                shape="rect"
                coords="1146, 2883, 1559, 2970"
              />
            </map>

            <img src="/img/event/event220425/backimg_1.png" useMap="#Map2" />
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event20220425_costory));
